import request from './request.js';

/**
 * @param accountID
 * @returns {Promise<unknown>}
 */
function getWhitelabel(accountID) {
    const options = {
        endpoint: `/user/whitelabel/auth/${ accountID }`,
        method: 'GET',
        skipAuth: true
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param {*} body
 */
function signup(body) {
    const options = {
        endpoint: '/user',
        method: 'POST',
        skipAuth: true,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param body
 * @returns {Promise<unknown>}
 */
function marketplaceOnlySignup(body) {
    const options = {
        endpoint: '/user/marketplaceOnly',
        method: 'POST',
        skipAuth: true,
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param affiliateLinkID
 */
function validateAffiliateLink(affiliateLinkID) {
    const options = {
        endpoint: `/user/validate/affiliateLink/${ affiliateLinkID }`,
        method: 'GET',
        skipAuth: true
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param accountID
 * @returns {Promise<any>}
 */
function getSignupData(userID, accountID) {
    const options = {
        endpoint: `/user/signup/${ accountID }/${ userID }`,
        method: 'GET',
        skipAuth: true
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param userID
 * @param accountID
 * @returns {Promise<unknown>}
 */
function initStripe(userID, accountID, language) {
    const options = {
        endpoint: `/user/initStripe/${ accountID }/${ userID }`,
        method: 'POST',
        skipAuth: true,
        body: {
            language
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    validateAffiliateLink,
    getWhitelabel,
    signup,
    marketplaceOnlySignup,
    getSignupData,
    initStripe
};